<template>
    <div class="home_wrap">
        <div class="red_top_bg">
            <div class="msg">
                <img src="@/assets/img/logo.png" alt="">
            </div>
            <div class="language" @click="$router.push('/language')">
                <img :src="require('../images/language/'+lang+'.png')" alt="">
            </div>
        </div>
        <div class="pla"></div>

        <div class="cont">
        	<van-swipe
        		v-if="data.banner && data.banner.length"
        		ref="homeSwipe"
        		:key="'swipe-' + lang + '-' + data.banner.length"
        		:autoplay="2500"
        		class="swiper-container"
        		@change="onChange"
        	>
        		<van-swipe-item v-for="(image, index) in data.banner" :key="index">
        			<router-link :to="image.url">
        				<img :src="bannerSrc(image)" alt="">
        			</router-link>
        		</van-swipe-item>
        		<div ref="dian" slot="indicator" class="custom-indicator">
        			<div v-for="(img, x) in data.banner" :key="x" :class="x===0?'selected':''"
        			/>
        		</div>
        	</van-swipe>
        	<div v-if="noticeText" class="notice-bar">
        		<van-notice-bar scrollable left-icon="volume-o" :text="noticeText"/>
        	</div>

			
			<div style="padding: 4px 4px 2px 2px; display: flex; flex-wrap: nowrap; background: #0e298d00;  border-radius: 10px; justify-content: space-between; margin: 10px 2% 0 2%; width: 96%;">
			
				<div style="width: 25%; text-align: center; margin-bottom: 10px;" @click="$router.push('/sign')">
					<div style="width: 100%; border-radius: 5px; overflow: hidden;">
						<img style="width: 44px; height: 44px;" src="../images/about/icon12.png" alt="">
					</div>
					<p style="width: 100%; line-height: 14px; font-size: 12px; color: #fff; text-align: center; transform: scale(0.85);">
				{{ $t('index.sign') }}
					
					</p>
				</div>
				
				<div style="width: 25%; text-align: center; margin-bottom: 10px;" @click="$router.push('/myTeam')">
					<div style="width: 100%; border-radius: 5px; overflow: hidden;">
						<img style="width: 44px; height: 44px;" src="../images/about/icon8.png" alt="">
					</div>
					<p style="width: 100%; line-height: 14px; font-size: 12px; color: #fff; text-align: center; transform: scale(0.85);">
						{{ $t('index.invite') }}
					</p>
				</div>
				
				<div style="width: 25%; text-align: center; margin-bottom: 10px;" @click="$router.push('/invest')">
					<div style="width: 100%; border-radius: 5px; overflow: hidden;">
						<img style="width: 44px; height: 44px;" src="../images/about/icon14.png" alt="">
					</div>
					<p style="width: 100%; line-height: 14px; font-size: 12px; color: #fff; text-align: center; transform: scale(0.85);">
						{{ $t('index.recharge') }}
					</p>
				</div>
				
				<div style="width: 25%; text-align: center; margin-bottom: 10px;" @click="$router.push('/cash')">
					<div style="width: 100%; border-radius: 5px; overflow: hidden;">
						<img style="width: 44px; height: 44px;" src="../images/about/icon2.png" alt="">
					</div>
					<p style="width: 100%; line-height: 14px; font-size: 12px; color: #fff; text-align: center; transform: scale(0.85);">
						{{ $t('index.withdraw') }}
					</p>
				</div>
				<div style="width: 25%; text-align: center; margin-bottom: 10px;" @click="$router.push('/activity')">
					<div style="width: 100%; border-radius: 5px; overflow: hidden;">
						<img style="width: 44px; height: 44px;" src="../images/about/icon6.png" alt="">
					</div>
					<p style="width: 100%; line-height: 14px; font-size: 12px; color: #fff; text-align: center; transform: scale(0.85);">
							{{ $t('home.activity') }}
					</p>
				</div>
				
			</div>
			
			
            <HomeRegion :title="$t('item.tab1')" @moreClick="$router.push('/itemNew')">
                <div class="flex-box">
                    <HomeReginSmallItem
                            style="width: 49%"
                            @click="$router.push('/item/'+item.id)"
                            v-for="(item,index) in (data.item1 && data.item1.list) || []"
                            v-show="index < 2"
                            :key="item.id"
                            :logo="item.img"
                            :name="item[lang]"
                            :vip="item.user_member"
                            :rate="item.rate"
                            :day="item.sy_ms == 1 ? item.hours :item.day"
                            :amount="parseInt(item.max)"
                            :used="item.used"
                            :total="item.num"
                            :percent="item.percent"
                            :ms="item.sy_ms"
                    />
                </div>
            </HomeRegion>

     <!--       <HomeRegion :title="$t('item.tab2')" @moreClick="$router.push('/itemNew?type=2')">
                <div class="flex-box-col">
                    <HomeReginBigItem
                            style="width: 100%"
                            @click="$router.push('/item/'+item.id)"
                            v-for="(item,index) in data.item2.list"
                            v-show="index < 2"
                            :key="item.id"
                            :logo="item.img"
                            :name="item[lang]"
                            :rate="item.rate"
                            :day="item.sy_ms == 1 ? item.hours :item.day"
                            :amount="parseInt(item.max)"
                            :used="item.used"
                            :total="item.num"
                            :percent="item.percent"
                            :ms="item.sy_ms"
                    />
                </div>
            </HomeRegion>
            <HomeRegion :title="$t('item.tab3')" @moreClick="$router.push('/itemNew?type=3')">
                <div class="flex-box-col">
                    <HomeReginBigItem
                            style="width: 100%"
                            @click="$router.push('/item/'+item.id)"
                            v-for="(item,index) in data.item3.list"
                            v-show="index < 2"
                            :key="item.id"
                            :logo="item.img"
                            :name="item[lang]"
                            :rate="item.rate"
                            :day="item.sy_ms == 1 ? item.hours :item.day"
                            :amount="parseInt(item.max)"
                            :used="item.used"
                            :total="item.num"
                            :percent="item.percent"
                            :ms="item.sy_ms"
                    />
                </div>
            </HomeRegion>

            <HomeRegion :title="$t('lang.投资管家')" :isShowMore="false">
                <div class="flex-box">
                    <video class="video" :src="data.sp.content_" controls=""></video>
                </div>
            </HomeRegion> -->
            <HomeRegion :title="$t('lang.新闻资讯')" :is-show-more="false">
                <div class="flex-box-col" style="width: 100%">
                    <NewsItem @click="$router.push('about/'+ item.id)"
                        v-for="item in newsList"
                        :key="item.id"
                        :url="item.img"
                        :desc="item['title_'+lang]"
                    />
                </div>
            </HomeRegion>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index"
import HomeRegion from '@/components/HomeRegion/index.vue';
import HomeReginSmallItem from '@/components/HomeRegionItem/small.vue'
import HomeReginBigItem from '@/components/HomeRegionItem/big.vue'
import NewsItem from '@/components/NewsItem/index.vue';
import {
    Swipe,
    SwipeItem,
    Icon,
    Progress,
    Dialog,
    Field,
    NoticeBar
} from "vant";

Vue.use(Icon).use(Progress).use(Dialog).use(Field);

export default {
    name: "Index",
    components: {
        NewsItem,
        HomeReginBigItem,
        HomeReginSmallItem,
        HomeRegion,
        VanNoticeBar: NoticeBar,
        VanSwipe: Swipe,
        VanSwipeItem: SwipeItem,
    },
    data() {
        return {
            show_kefu: false,
            msg_show: true,
            loading: false,
            icon: [],
            data: {},
            show_img: false,
            show_tz: false,
            show_tc: false,
            tc_content: "",
            number: '',
            sku: [],
            newsList:[]
        };
    },
    computed: {
        lang() {
            const locale = this.$i18n && this.$i18n.locale;
            if (locale) {
                return locale;
            }
            try {
                const stored = localStorage.getItem('lang');
                if (stored) {
                    return stored;
                }
            } catch (e) { /* ignore */ }
            return 'zh_cn';
        },
        noticeText() {
            const gg = this.data.gg;
            if (!gg) {
                return '';
            }
            const byLang = gg['content_' + this.lang];
            if (byLang) {
                return byLang;
            }
            return gg.content_zh_cn || '';
        },
    },
    created() {
        this.$parent.footer('index');
        this.getNews()
    },
    mounted() {
        this.start();
        //代理标识设置
        if (this.$router.history.current.query.agent) {
            localStorage.setItem('agent', this.$router.history.current.query.agent);
        }
        console.log();
        var that = this;
        document.body.addEventListener("scroll", function () {
            if (!that.show_kefu) {
                return;
            }
            that.show_kefu = false;
        }, false);
        document.addEventListener('click', function (ev) {
            if (ev.target.className != 'kefu_img') {
                that.show_kefu = false;
            }
        }, false);
    },
    methods: {
        getNews() {
            Fetch('/index/getNews').then(res => {
                this.newsList = res.data.list
            })
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push('/kefu');
            }
            this.show_kefu = !this.show_kefu;
        },
        hideDown() {
            this.show_img = false;
            this.$store.commit('setShowAdvert', false);
        },
        bannerSrc(image) {
            if (!image || typeof image !== 'object') {
                return '';
            }
            const key = this.lang;
            if (image[key]) {
                return image[key];
            }
            return image.zh_cn || image.en_us || '';
        },
        start() {
            Fetch('/index/int').then((r) => {
               
                this.data = r.data;
                this.loading = true;
                if (r.data.popup && r.data.popup.show == 1) {
                    this.tc_content = r.data.popup.content;
                    this.show_tc = true;
                }
                this.$nextTick(() => {
                    const swipe = this.$refs.homeSwipe;
                    if (swipe && typeof swipe.resize === 'function') {
                        swipe.resize();
                    }
                });
			
            });
        },
        onChange(index) {
            if (!this.$refs.dian) {
                return;
            }
            let els = this.$refs.dian.querySelectorAll("div");
            for (let i = 0; i < els.length; i++) {
                els[i].className = "";
            }
            if (els[index]) {
                els[index].className = "selected";
            }
        },
        buy(item) {
            this.sku = item;
            this.show_tz = true;
        },
        confirm() {
            if (!this.number) {
                this.$toast(this.$t('item.inputAmount'));
                return false;
            }
            Fetch("/index/item_apply", {
                id: this.sku.id,
                money: this.number
            }).then(r => {
                this.$router.push("/order");
            }).catch(err => {
                this.psd_val = '';
            })
        }
    }
};
</script>

<style lang="less" scoped>
.video {
  margin-top: 20px;
  width: 90%;
  height: 225px;
}

/deep/ .van-cell {
  padding: 15px 26px;
}

/deep/ .van-notice-bar {
  background: linear-gradient(90deg, rgba(231, 197, 170, 1) 0%, rgba(246, 229, 213, 1) 49%, rgba(230, 199, 155, 1) 100%) !important;
  color: rgb(58, 33, 13) !important;
}

.flex-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.flex-box-col {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
}

.notice-bar {
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.cont{
  height: calc(100% - 60px);
  height: 100%;
  padding: 10px 10px 100px 10px ;
  overflow-y: scroll;
}

.home_wrap {
  width: 100%;
  height: calc(100vh - 60px);
  //height: 100vh;
  overflow-y: visible;
  background: #ffffff;

  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
}

.pla{
  width: 100%;
  height: 50px;
}
.red_top_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  color: rgb(239, 216, 196);
  background: rgb(35, 29, 29);
  height: 50px;

  .language {
    position: absolute;
    top: 4px;
    right: 0;
    height: 36px;

    img {
      height: 100%;
    }
  }

  .msg {
    position: absolute;
    top: 2px;
    left: 6px;
    height: 40px;

    img {
      height: 100%;
    }
  }
}

.search_box {
  width: 80%;
  height: 29px;
  background-color: #f6f6f6;
  border-radius: 17px;
  margin: 8px 50px 0 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px 0 14px;

  .fdj {
    width: 16px;
    height: 16px;
    background: url(../images/item/fdj.png) no-repeat center center;
    background-size: 100% 100%;
  }

  .search_inp {
    flex: 1;
    margin: 0 8px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    height: 20px;
  }

  .clear_inp {
    width: 20px;
    height: 20px;
    background: url(../images/item/clear.png) no-repeat center center;
    background-size: 100% 100%;
  }
}

.swiper-container {
  width: 100%;
  height: 172px;
  margin-top: 0px;
  background: #FFFFFF;
  border-radius: 6px;
  overflow: hidden;

  .van-swipe-item {
    overflow: hidden;
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
  }

  img {
    border-radius: 6px;
 
    height: 100%;
    width: 100%;
  }
}

.work_box {
  background: #ffffff;
  padding: 17px 8px 4px 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    width: 25%;
    text-align: center;
    margin-bottom: 10px;

    .item_img {
      width: 100%;
      border-radius: 5px;
      overflow: hidden;

      img {
        width: 44px;
        height: 44px;
      }
    }

    .item_title {
      width: 100%;
      line-height: 14px;
      font-size: 12px;
      color: #607d8b;
      text-align: center;
      transform: scale(0.85);
      font-weight: 600;
    }
  }
}

.work_box.query {
  .item {

    .item_img {
      border-radius: 5px;
      background: #f0f0f0;
    }

    .item_title {
      width: 100%;
      height: 14px;
      margin-left: 0;
      background: #f0f0f0;
    }
  }

}

.ads_box_1 {
  border-radius: 13px;
  margin-top: 10px;
  text-align: center;

  img {
    width: 95%;
  }
}

.ads_box {
  // background: rgba(255, 255, 255, 1);
  width: 97%;
  border-radius: 13px;
  margin: 10px auto 0 auto;
  display: flex;
  text-align: center;

  .ads_img {

  }

  img {
    width: 96%;
    border-radius: 5px;
  }
}

.items_1,
.items_2,
.items_3 {
  margin: 10px 2% 0 2%;
  width: 96%;

  .items_tit {
    border-radius: 5px 5px 0 0;
    height: 44px;
    line-height: 44px;
    font-size: 12px;
    color: rgba(0, 0, 0, .8);
    background: #FFFFFF;
    border-bottom: 1px solid #F7F7F7;
    padding: 0 14px;
    display: flex;
    justify-content: space-between;

    .tit_tip {
      display: contents;
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;
      margin-left: 10px;
    }

    .tit_more {
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;

    }
  }

  .item {
    background: #FFFFFF;
  }
}

.items_1 {
  .item {
    padding: 5px;
    margin: 0 0 10px 0;
    border-radius: 5px;
    box-shadow: 0px 0px 0px 2px #1989fa !important;

    div {
      margin: 20px 0;
    }

    .item_tit {
      text-align: center;
      overflow: hidden;
      color: #3775f4;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
        font-size: 12px;
      }
    }

    .item_rate {
      text-align: center;
      color: #FF0000;
      font-size: 22px;
      font-weight: bold;
    }

    .item_desc {
      display: flex;

      p {
        width: 50%;
        text-align: center;
      }
    }

    .item_btn {
      text-align: center;

      button {
        width: 60%;
        min-width: 60px;
        background: #ff0c00;
        box-shadow: 0 1px 0px 5px rgba(176, 191, 238, .2) !important;
        color: #FFFFFF;
        padding: 10px 0px;
        border-radius: 5px;
      }

      .item_btn_over {
        background: #999;
      }
    }
  }
}

.items_2 {
  .item {
    display: flex;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #ECECEC;

    div {
      margin: 15px 0;
    }

    .item_rate {
      width: 20%;

      p {
        padding: 5px 0;
      }

      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;
        color: #FF0000;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_tit {
      width: 55%;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 5px 0;
      }

      p:nth-child(1) {
        font-weight: bold;
      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_btn {
      width: 25%;

      button {
        min-width: 60px;
        margin-top: 12px;
        color: #1989fa;
        padding: 5px 5px;
        border-radius: 5px;
        border: 1px solid #1989fa;
      }

      .item_btn_over {
        color: #999;
        border: 1px solid #999;
      }
    }
  }
}

.items_3 {
  .item {
    margin-bottom: 10px;

    div {
      margin: 5px 0;
    }

    .item_div1 {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ECECEC;
      padding: 15px 10px;

      p:nth-child(1) {
        // width: 70%;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_div2 {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 14px;

      div {
        width: 33.33%;

        p {
          padding: 5px 0;
        }
      }

      .item_rate {
        p:nth-child(1) {
          font-weight: bold;
          color: #FF0000;

        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_day {
        p:nth-child(1) {
          font-weight: bold;

        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_min {
        p:nth-child(1) {
          font-weight: bold;

        }

        p:nth-child(2) {
          color: #999;
        }
      }
    }

    .item_div3 {
      color: #999;
      padding: 5px 10px;
    }

    .item_div4 {
      padding: 5px 10px;
      display: flex;
      justify-content: space-between;

      div:nth-child(1) {
        width: 75%;
        margin-top: 16px;
      }

      .item_btn {
        width: 20%;

        button {
          min-width: 60px;
          color: #1989fa;
          padding: 5px 5px;
          border-radius: 5px;
          border: 1px solid #1989fa;
        }

        .item_btn_over {
          color: #999;
          border: 1px solid #999;
        }
		.s1{
			padding: 4px 4px 2px 2px;
			    display: flex;
			    flex-wrap: nowrap;
			    background: #0e298d00;
			    border-radius: 10px;
			    justify-content: space-between;
			    margin: 10px 2% 0 2%;
			    width: 96%;
		}
      }
    }
  }
}

.popup {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-height: 60vh;
  padding: 26px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
}
</style>
